import styled from "styled-components";
import {
  getAppearFromLeft,
  defaultAnimationDelay,
  defaultAnimationDuration,
} from "theme/animations";
import { DEMONSTRATION_ANIMATION_DURATION } from "configs/general";

interface ContainerProps {
  isOpen: boolean;
}

const PADDING = 20;
const FORM_MIN_WIDTH = 450;
const FORM_OPEN_WIDTH = FORM_MIN_WIDTH + PADDING;

export const Container = styled.div<ContainerProps>`
  z-index: 99;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  padding: ${PADDING}px;
  background-color: ${({ theme }) => theme.colors.light};
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
  animation: ${getAppearFromLeft()} ${defaultAnimationDuration}s;
  animation-delay: ${defaultAnimationDelay}s;
  animation-fill-mode: both;

  .title {
    transform: translateY(${({ isOpen }) => (isOpen ? "-100%" : 0)});
    opacity: ${({ isOpen }) => (isOpen ? 0 : 1)};
    transition: transform ${DEMONSTRATION_ANIMATION_DURATION},
      opacity ${DEMONSTRATION_ANIMATION_DURATION};
  }

  .right-container {
    width: ${({ isOpen }) => (isOpen ? FORM_OPEN_WIDTH : 0)}px;
    transition: width ${DEMONSTRATION_ANIMATION_DURATION};
    overflow: hidden;
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 160px;
  cursor: pointer;
`;

export const ImageContainer = styled.div`
  flex: 1;
  margin-top: 10px;
  width: 100%;
  max-width: 120px;
`;

export const FormContainer = styled.div`
  overflow: hidden;
  box-sizing: border-box;
  padding-left: ${PADDING}px;
  min-width: ${FORM_MIN_WIDTH}px;
`;
